/**
 * ============================================================
 * CDS — Utilitaires communs des assembleurs
 * Studio  : Chlo' Design Studio
 * Version : 1.0
 * Desc.   : Fonctions partagées entre cds-bundle-builder.js
 *           (Assembleur Bundle) et cds-outfit-finder.js
 *           (Assembleur Look) : ajout panier AJAX, helpers
 *           couleur, redimensionnement d'image, échappement
 *           HTML. Doit être chargé avant les deux assets dédiés
 *           dans chaque section assembleur.
 * API     : window.CDSBuilders.{cartSectionIds, dispatchCartUpdate,
 *           openCartDrawer, cartCount, isColorOpt, colorHex,
 *           COLOR_MAP, sizedImg, escapeHtml}
 * ============================================================
 */
(function () {
  'use strict';
  if (window.CDSBuilders) return;

  /* ---- Color map ---- */
  var COLOR_MAP = {
    'noir':'#000','black':'#000','blanc':'#fff','white':'#fff','rouge':'#c0392b','red':'#c0392b',
    'bleu':'#2980b9','blue':'#2980b9','vert':'#27ae60','green':'#27ae60','jaune':'#f1c40f','yellow':'#f1c40f',
    'rose':'#e91e8b','pink':'#e91e8b','orange':'#e67e22','violet':'#8e44ad','purple':'#8e44ad',
    'gris':'#95a5a6','grey':'#95a5a6','gray':'#95a5a6','marron':'#6d4c41','brown':'#6d4c41',
    'beige':'#d4c5a9','creme':'#f5f0e1','cream':'#f5f0e1','bordeaux':'#722f37','burgundy':'#722f37',
    'navy':'#1a237e','marine':'#1a237e','turquoise':'#1abc9c','corail':'#e74c3c','coral':'#e74c3c',
    'or':'#d4a843','gold':'#d4a843','argent':'#c0c0c0','silver':'#c0c0c0','kaki':'#6b6b3d','khaki':'#6b6b3d',
    'camel':'#c19a6b','ivoire':'#fffff0','ivory':'#fffff0','taupe':'#483c32','sable':'#c2b280','sand':'#c2b280'
  };
  var COLOR_NAMES = ['color','colour','couleur','farbe','colore','color/colour'];
  function isColorOpt(n){ return COLOR_NAMES.indexOf(n.toLowerCase().trim())>=0; }
  function colorHex(n){ return COLOR_MAP[n.toLowerCase().trim()]||null; }

  /* ---- Cart helpers ---- */
  function cartSectionIds(){
    var ids=[];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
      if(el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }
  /* sourceId identifie l'assembleur emetteur ('cds-bundle-builder' ou
     'cds-outfit-finder') — seule difference entre les deux implementations
     d'origine, desormais passee en parametre plutot que codee en dur. */
  function dispatchCartUpdate(sourceId, sections, pid, qty){
    var e=new Event('cart:update',{bubbles:true});
    e.detail={resource:{},sourceId:sourceId,data:{source:sourceId,productId:pid,itemCount:qty,sections:sections||{}}};
    document.dispatchEvent(e);
  }
  function openCartDrawer(){
    var d=document.querySelector('cart-drawer-component');
    if(!d){window.location.href='/cart';return;}
    function _t(){
      var t=document.querySelector('[data-testid="cart-drawer-trigger"]');
      if(t){t.click();return;}
      if(typeof d.showDialog==='function'){d.showDialog();return;}
      if(typeof d.open==='function'){d.open();return;}
    }
    if(d.hasAttribute('auto-open')){
      setTimeout(function(){if(!d.hasAttribute('open')&&!d.open)_t();},350);
      return;
    }
    _t();
  }
  function cartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.cart-count,[data-cart-count],.cds-hg__badge').forEach(function(e){
        e.textContent=c.item_count;
        if(c.item_count>0)e.style.display='';
      });
    }).catch(function(){});
  }

  /* ---- Image helper ---- */
  function sizedImg(src, size){
    if(!src) return '';
    return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)(\.|_)/,'.$2')
      .replace(/\.([^.]+)$/,'_'+size+'.$1');
  }

  /* ---- HTML escaping ---- */
  function escapeHtml(str){
    var div=document.createElement('div');
    div.textContent=str;
    return div.innerHTML;
  }

  window.CDSBuilders = {
    cartSectionIds: cartSectionIds,
    dispatchCartUpdate: dispatchCartUpdate,
    openCartDrawer: openCartDrawer,
    cartCount: cartCount,
    isColorOpt: isColorOpt,
    colorHex: colorHex,
    COLOR_MAP: COLOR_MAP,
    sizedImg: sizedImg,
    escapeHtml: escapeHtml
  };
})();
